// extracted by mini-css-extract-plugin
export default {"wrapper":"menuTile_wrapper__TTZSm","icon":"menuTile_icon__vJJGL"};